import {EditGuesser, ListGuesser, ShowGuesser} from "react-admin";

import MenuBookIcon from '@mui/icons-material/MenuBook';

const RegionResourceProps = {
    name: "region",
    list: ListGuesser,
    edit: EditGuesser,
    show: ShowGuesser,
};

export const RegioneMenuProps = {
    to: "/region",
    primaryText: "Region",
    icon: MenuBookIcon,
};

export default RegionResourceProps;
